import { render, staticRenderFns } from "./videoIntercom.vue?vue&type=template&id=2c6f33db&scoped=true"
import script from "./videoIntercom.vue?vue&type=script&lang=js"
export * from "./videoIntercom.vue?vue&type=script&lang=js"
import style0 from "./videoIntercom.vue?vue&type=style&index=0&id=2c6f33db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f33db",
  null
  
)

export default component.exports